// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/MinusCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var MinusCircleOutlined = function MinusCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleOutlinedSvg
  }));
};

MinusCircleOutlined.displayName = 'MinusCircleOutlined';
export default React.forwardRef(MinusCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MinusCircleOutlined.js
// module id = 1489
// module chunks = 0